/* tslint:disable */
/* tslint:disable */
/**
 * ClearFlask Admin API
 * ClearFlask API documentation.
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/* tslint:disable */
// eslint-disable-next-line no-unused-vars
import { exists } from '../runtime';
/**
 * 
 * @export
 * @interface AccountBillingPaymentActionRequired
 */
export interface AccountBillingPaymentActionRequired {
    /**
     * 
     * @type {string}
     * @memberof AccountBillingPaymentActionRequired
     */
    actionType?: string;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof AccountBillingPaymentActionRequired
     */
    actionData?: { [key: string]: string; };
}

export function AccountBillingPaymentActionRequiredFromJSON(json: any): AccountBillingPaymentActionRequired {
    return {
        'actionType': !exists(json, 'actionType') ? undefined : json['actionType'],
        'actionData': !exists(json, 'actionData') ? undefined : json['actionData'],
    };
}

export function AccountBillingPaymentActionRequiredToJSON(value?: AccountBillingPaymentActionRequired): any {
    if (value === undefined) {
        return undefined;
    }
    return {
        'actionType': value.actionType,
        'actionData': value.actionData,
    };
}


